import { z } from 'zod';
const entrySchema = z
  .object({
    organizationId: z.string().min(1),
    locationId: z.string().min(1),
    request: z.string().trim().min(1).max(8000),
    expiresAt: z.number(),
    claimed: z.boolean(),
  })
  .strict();
const key = (token: string) => `claire-designer-handoff:${token}`;
/** Minted only by the human approval action; prompts never enter the URL. */
export function approveDesignerHandoff(input: {
  organizationId: string;
  locationId: string;
  request: string;
}) {
  const token = crypto.randomUUID();
  const entry = entrySchema.parse({
    organizationId: input.organizationId,
    locationId: input.locationId,
    request: input.request,
    expiresAt: Date.now() + 10 * 60_000,
    claimed: false,
  });
  sessionStorage.setItem(key(token), JSON.stringify(entry));
  return token;
}
/** Validate the scoped, expiring approval before admission or acknowledgement. */
function readDesignerHandoff(
  token: string,
  organizationId: string,
  locationId: string
) {
  if (!z.uuid().safeParse(token).success) return null;
  try {
    const entry = entrySchema.parse(
      JSON.parse(sessionStorage.getItem(key(token)) || 'null')
    );
    if (
      entry.claimed ||
      entry.expiresAt < Date.now() ||
      entry.organizationId !== organizationId ||
      entry.locationId !== locationId
    )
      return null;
    return entry;
  } catch {
    return null;
  }
}

/** Unaccepted requests survive reload; retries retain the server idempotency key. */
export function claimDesignerHandoff(
  token: string,
  organizationId: string,
  locationId: string
) {
  const entry = readDesignerHandoff(token, organizationId, locationId);
  return entry ? { request: entry.request, operationId: token } : null;
}
/** Consume the approval only after successful API admission. */
export function acknowledgeDesignerHandoff(
  token: string,
  organizationId: string,
  locationId: string
) {
  const entry = readDesignerHandoff(token, organizationId, locationId);
  if (!entry) return;
  try {
    sessionStorage.removeItem(key(token));
  } catch {
    // A lost acknowledgement can only repeat the same server-idempotent operation.
  }
}
